export default __webpack_public_path__ + "static/media/timer.c7bf3751.png";